module.exports = __webpack_public_path__ + "static/1-8c34020a5965c10ca5e02a38237c7608.jpg";